<template>
    <section class="orderdatatable-grid">
        <acclaro-datatable
            ref="acclaroSearchView"
            grid-title="Programs"
            search-route="/datatables/programs/data"
            aggregate-route="/datatables/programs/aggregates"
            filter-route="/datatables/programs/filters"
            datatable-name="programs"
            :search-param="options.searchParam"
            search-placeholder="Enter Program Name..."
            :tags-param="options.tagsParam"
            :filter-param="options.filtersParam"
            :filter-by-param="options.filterByParam"
            :column-templates="templates"
            :column-structure="columns"
            :options="datatableOptions"
            :limit="10"
            :show-search-filter="false"
            :show-density-setting="false"
        >
            <template v-slot:aggregates="props">
                <ul>
                    <li><strong>Order Count:</strong> {{ numberWithCommas(props.aggregates.order_count || 0) }}</li>
                    <li><strong>Active Programs:</strong> {{ props.aggregates.active || 0 }}</li>
                    <li><strong>Total Budget Amount:</strong> {{ props.aggregates.total_budget }}</li>
                </ul>
            </template>
        </acclaro-datatable>
    </section>
</template>

<script>
import './styles/order-datatable.scss';

import {AsLink, AsStatus} from '../Acclaro-Datatable/cells';

import statusColors from '../Acclaro-Datatable/statusColors.js';
import './styles/programs-datatable.scss';
import {handleMakeOrder} from "./helpers";

export default {

    props: {

        options: {
            type: Object,
            required: true
        }
    },

    data() {
        return {

            datatableOptions: {
                orderBy: {
                    ascending: false,
                    column: 'ID'
                },
                columnsClasses: {
                    Name: 'th-order-name'
                },
            }
        }
    },

    computed: {
        columns() {
            return {
                name: {displayName: 'Name'},
                order_type: {displayName: 'Order Type'},
                count_total: {displayName: 'Total Orders'},
                count_in_progress: {displayName: 'Orders In Progress'},
                count_complete: {displayName: 'Completed Orders'},
                budget_amount: {displayName: 'Budget'},
                spent: {displayName: 'Orders Total'},
                quote_amount: {displayName: 'Quote Amount'},
                last_order: {displayName: 'Latest Order'},
                automation: {displayName: 'Automation'},
                status: {displayName: 'Status'},
                create_order: {displayName: 'Create Order'},
            }
        },
        templates() {
            let $vm = this;
            return {
                'Name': function (h, row, index) {
                    return (
                        <AsLink
                            link={row.url}
                            link-text={row.name}
                        />
                    )
                },
                'Latest Order': function (h, row, index) {
                    return (
                        <AsLink
                            link={row.last_order_route}
                            link-text={row.last_order_name}
                        />
                    )
                },
                Status: function (h, row, index) {
                    const props = { row, column: 'Status' };
                    return (
                        <AsStatus props={props}>
                            <span class={'status-dots status-' + $vm.getStatusColor(row.status)}></span>
                        </AsStatus>
                    );
                },
                'Order Type': function (h, row, index) {
                    return row.order_type;
                },
                'Budget': function (h, row, index) {
                    return row.budget_amount ? row.budget_amount : '-';
                },
                'Total Orders': function (h, row, index) {
                    return row.count_visible_order;
                },
                'Orders In Progress': function (h, row, index) {
                    return row.count_in_progress;
                },
                'Completed Orders': function (h, row, index) {
                    return row.count_complete;
                },
                'Quote Amount': function (h, row, index) {
                    return this.strToPrice(row.orders_sum_quoteprice);

                },
                'Total Words': function (h, row, index) {
                    return row.orders_sum_total_words ?? '-';

                },
                'Orders Total': function (h, row, index) {
                    return this.strToPrice(row.orders_sum_price);

                },
                'Automation': function (h, row, index) {
                    if (row.has_program_scheduler_enabled) {
                        return <i class="acclaro-icon icon-scheduler"></i>
                    } else {
                        return "-"
                    }
                },
                'Create Order': function (h, row, index) {
                    if(row.status === 'Active'){
                        return <button class="make_order" onClick={() => handleMakeOrder(row.id, row.name)}><span style="margin-right: 0px; vertical-align: bottom;" class="acclaro icon bg-createorder"></span></button>;
                    }
                },
            }
        },
    },

    methods: {
        strToPrice(amount) {
            let amountFloat = parseFloat(amount);

            if (isNaN(amountFloat) || amountFloat == 0) {
                return '-';
            }


            return formatter.format(amount);
        },

        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        getStatusColor(status) {
            return statusColors[status.toLowerCase()];
        },
    }
}
</script>
